import { WidgetRegistry } from "@Widgets/types";
import { ServiceOfferModalWithButton } from "../Components/ServiceOfferModalWithButton";
import { ServiceRequestCreationRoot } from "../ServiceRequestCreation/Containers/ServiceRequestCreationRoot/ServiceRequestCreationRoot";
import { StaleTaskModalRoot } from "../Containers/StaleTaskModalRoot/StaleTaskModalRoot";

const serviceRequestWidgetRegistry: Pick<
  WidgetRegistry,
  | "ServiceRequest.See.Offer.Detail"
  | "TasksCreation.Root"
  | "ServiceRequest.StaleTaskModal"
> = {
  "ServiceRequest.See.Offer.Detail": {
    Component: ServiceOfferModalWithButton,
  },
  // The widget key stays as Rails renders it
  // (`app/views/tasks_creation/new.html.erb`); only the React side moved into
  // `ServiceRequestCreation`.
  "TasksCreation.Root": {
    Component: ServiceRequestCreationRoot,
  },
  "ServiceRequest.StaleTaskModal": {
    Component: StaleTaskModalRoot,
  },
};

export default serviceRequestWidgetRegistry;
